/* v8 ignore start -- @preserve */

import { type CountryCode } from "libphonenumber-js";

import { type CountryResponse } from "@vega-api/generated/types/countryResponse";
import { DEFAULT_PHONE_CODE } from "@vega-core/constants/global";
import { type OptionType } from "@vega-core/models/options";
import { isTruthy } from "@vega-core/utils/isTruthy";

export const countriesToOptions = (
  countries: CountryResponse[],
): OptionType[] => countries.map((country) => getCountryMetadata(country));

export function getCountryMetadata(country: CountryResponse): CountryMetadata {
  return {
    icon: `/images/flags/${isTruthy(country.alpha2) ? country.alpha2.toLowerCase() : ""}.svg`,
    label: country.name as string,
    value: country.alpha2 as CountryCode,
  };
}

export type CountryMetadata = {
  icon: string;
  label: string;
  value: CountryCode;
};

export type PhoneCodeOption = {
  icon: string;
  inputLabel: string;
  label: string;
  regionCode: CountryCode;
  value: string;
};

export enum GeographicRegions {
  AFRICA = "AFRICA",
  ANTARCTICA = "ANTARCTICA",
  ASIA = "ASIA",
  AUSTRALIA = "AUSTRALIA",
  EUROPE = "EUROPE",
  NORTHAMERICA = "NORTH_AMERICA",
  SOUTHAMERICA = "SOUTH_AMERICA",
}

export const regionsToOptions = (regions: GeographicRegions[]): OptionType[] =>
  regions.map((region) => ({
    icon: <div />, // TODO add globe icon
    label: region,
    value: region,
  }));

export const phoneCodesOptions = (
  countries: CountryResponse[],
): OptionType[] => {
  const res = countries
    .filter((v: CountryResponse) => isTruthy(v.phoneCode) && v.phoneCode !== "")
    .sort((a) => (a.alpha2 === "US" ? -1 : 0))
    .map((c: CountryResponse) => ({
      icon: `/images/flags/${isTruthy(c.alpha2) ? c.alpha2.toLowerCase() : ""}.svg`,
      inputLabel: c.phoneCode,
      label: `${c.name}   ${c.phoneCode}`,
      regionCode: c.alpha2,
      value: c.phoneCode,
    })) as PhoneCodeOption[];

  return res.length !== 0 ? res : [DEFAULT_PHONE_CODE];
};
